import { SourceEntityMigrationType } from '@principle-theorem/practice-migrations/interfaces';
import { SourceEntity } from '../../../source/source-entity';
import { PatientTransactionsSourceEntity } from './patient-transactions';

export const PATIENT_DISCOUNT_RESOURCE_TYPE = 'patientDiscount';

export const PATIENT_DISCOUNT_SOURCE_ENTITY = SourceEntity.init({
  metadata: {
    label: 'Patient Discounts List',
    description: '',
    idPrefix: PATIENT_DISCOUNT_RESOURCE_TYPE,
    migrationType: SourceEntityMigrationType.Automatic,
  },
});

const PATIENT_DISCOUNT_QUERY = `
SELECT
  patient_transactions.*,
  treatment_codes.display_code,
  treatment_codes.item_code,
  treatment_codes.service_description,
  treatment_codes.code_type,
  treatment_codes.payment_code_type
FROM (
  SELECT
    transid AS transaction_id,
    respons_person_id AS response_patient_id,
    patient_persion_id AS patient_person_id,
    visit_id,
    entry_date AS created_date,
    service_date,
    tx_code_id AS treatment_code_id,
    producer_employee_id AS producer_staff_id,
    provider_employee_id AS provider_staff_id,
    ar_owner_employee_id AS owner_staff_id,
    convert_to_decimal(total_amount) AS total_amount,
    groupid AS group_id
  FROM
    _ledger_history_
  WHERE transid IS NOT NULL AND (trans_type = 6 OR trans_type = 5) AND convert_to_decimal(total_amount) != 0
) AS patient_transactions
LEFT JOIN (
  SELECT
    tx_code_id AS code_id,
    NULLIF(user_id, '') AS display_code,
    convert_to_text(medical_code) AS item_code,
    description AS service_description,
    code_type,
    pmt_code_type AS payment_code_type
  FROM
    _tx_code_defs_
) AS treatment_codes ON patient_transactions.treatment_code_id = treatment_codes.code_id
`;

export class PatientDiscountSourceEntity extends PatientTransactionsSourceEntity {
  override sourceEntity = PATIENT_DISCOUNT_SOURCE_ENTITY;
  override entityResourceType = PATIENT_DISCOUNT_RESOURCE_TYPE;
  override sourceQuery = PATIENT_DISCOUNT_QUERY;
}
